import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlignLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M2.25 5A.75.75 0 0 1 3 4.25h10a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 5m0 5A.75.75 0 0 1 3 9.25h14a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m0 5a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAlignLeft;
